import { formatMoney, hideCartIcon, toggleLoading } from 'helpers/utils';
import { item } from 'js/modules/create-order-builder';
import { removeProduct, updateProductQty, fetchCart } from 'helpers/api';
import { updateAllowableFreight } from './allowable-freight-promo';
import { getCartCount } from './sidecart';

const order = {};
const _cart = document.getElementsByClassName('js--ob-cart')[0];
let noItems = null;
let largeQtyModalViewed = false;
const modals = {
    qty: false,
    backorder: false,
    min: false,
};
let minimunOrderFeeThreshold;
let totalParts;

// ==================================================
// INITIALIZERS
// ==================================================

async function setProductList() {
    const cartList = document.getElementsByClassName('js--ob-cart')[0];
    const cartTotal = document.getElementsByClassName('js--ob-total')[0];

    const [{ CartItems: items, User }, summary] = await Promise.all([fetchCart(), getCartCount()]);

    minimunOrderFeeThreshold = User.NetSuiteCustomer.MINIMUM_ORDER_FEE_THRESHOLD;
    totalParts = summary.CartTotal;

    //console.log(minimunOrderFeeThreshold);

    if (!items.length) {
        cartList.innerHTML = '';
        cartList.appendChild(noItems);
        cartTotal.innerHTML = `$0.00`;
        toggleLoading();
        return (document.querySelector('.js--ob-no-items p').innerHTML = 'No Items Selected.');
    }

    document.getElementsByClassName('js--ob-cart')[0].innerHTML = items
        .map((k, i) => {
            const product = {
                ...k.NetSuiteItem,
                Availability: k.Availability,
                qty: k.Quantity,
                Description: k.NetSuiteItem.SalesDescription,
                PackageNotes: k.PackageNotes,
                ActualCost: k.ActualDealerCost,
                PartNote: k.PartNote,
                CartItemId: k.ShoppingCartId,
                review: true,
                Id: k.Id,
                BackorderQuantity: k.BackorderQuantity || 0,
                SmartshipQuantity: k.SmartShipQuantity || 0,
                ETADate: k.ETADate,
                AlternateWarehouseId: k.AlternateWarehouseId,
                AlternateWarehouseNote: k.AlternateWarehouseNote,
            };

            console.log('PRODUCT:', product);

            order[k.Id] = { ...product, order: i };
            return `<li>${item({ ...product, displayNoteEdit: true })}</li>`;
        })
        .join('');

    cartTotal.innerHTML = formatMoney(summary.CartTotal);

    Array.from(document.getElementsByClassName('js--ob-remove')).forEach((k) =>
        k.addEventListener('click', (e) => removeItem(e)),
    );

    Array.from(document.getElementsByClassName('js--ob-li-qty')).forEach((k) =>
        ['keyup', 'blur'].forEach((j) => k.addEventListener(j, (e) => checkQtyVal(e))),
    );

    toggleLoading();

    // add note toggle event listeners
    Array.from(document.getElementsByClassName('js--add-note')).forEach((k) =>
        k.addEventListener('click', (e) => handleAddNoteToggle(e)),
    );

    // cancel note event listeners
    Array.from(document.getElementsByClassName('js--note-cancel')).forEach((k) =>
        k.addEventListener('click', (e) => handleAddNoteToggle(e, false)),
    );

    // save note event listeners
    Array.from(document.getElementsByClassName('js--note-save')).forEach((k) =>
        k.addEventListener('click', (e) => {
            handleSaveNote(e);
            handleAddNoteToggle(e, false);
        }),
    );
}

// ==================================================
// HANDLERS
// ==================================================

function toggleModal(el = '', hide) {
    const modal = document.querySelector(`.js--modal-${el}`);
    const overlay = document.getElementsByClassName('js--modal-overlay')[0].classList;
    const hidden = 'pd-modal--hidden';
    modals[el] = true;

    if (hide) {
        modals[el] = false;
        modal.classList.add(hidden);
    } else {
        modal.classList.remove(hidden);
        modals[el] = true;
    }

    return modals.qty || modals.backorder || modals.min
        ? overlay.remove(hidden)
        : overlay.add(hidden);
}

function closeLargeQuantityModal() {
    largeQtyModalViewed = true;
    toggleModal('qty', true);
}

function handleContinue(e) {
    e.preventDefault();

    let backordered = false;
    const largeQtyItems = Object.keys(order)
        .filter((k) => {
            if (order[k].Availability === 300) {
                backordered = true;
            }

            return order[k].qty >= 1000;
        })
        .map((k) => ({
            qty: order[k].qty,
            title: order[k].FullPartNumber,
        }));

    if (largeQtyItems.length && !largeQtyModalViewed) {
        document.getElementsByClassName('js--modal-large-qty')[0].innerHTML = largeQtyItems
            .map((k) => largeQtyLi({ ...k }))
            .join('');

        toggleModal('qty');
    }

    if (backordered) {
        toggleModal('backorder');
    }

    // if (totalParts < 25 && customerFreightTerm < 25) {
    //   toggleModal('min')
    // }
    if (totalParts < minimunOrderFeeThreshold) {
        toggleModal('min');
    } else if (!modals.backorder && (!largeQtyItems.length || largeQtyModalViewed)) {
        window.location = e.target.getAttribute('href');
    }

    return false;
}

async function removeItem(e) {
    e.preventDefault();

    const target = e.target.nodeName === 'I' ? e.target.closest('button') : e.target;
    const cartId =
        target.tagName.toLowerCase() === 'button'
            ? target.getAttribute('data-id')
            : target.closest('button').getAttribute('data-id');

    if (Object.keys(order).indexOf(cartId) !== -1) {
        await removeProduct(cartId, 'checkout-cart:removeItem');
        target.closest('li').remove();
        const summary = await getCartCount();
        console.log('Summary CartTotal', summary);
        document.getElementsByClassName('js--review-total')[0].innerHTML = formatMoney(
            summary.CartTotal,
        );
    }
}

async function checkQtyVal(e) {
    e.target.value = e.target.value.replace(/[^\d+$]/g, '');
    const noteContainer = e.target.closest('li').getElementsByClassName('js--upload-note');

    if (e.keyCode === 13 || e.type === 'blur') {
        largeQtyModalViewed = false;
        const { Quantity, Product } = await updateProductQty({
            cartItemId: e.target.getAttribute('data-id'),
            qty: e.target.value,
            note: noteContainer && noteContainer.length ? noteContainer[0].innerHTML : null,
        });
        setProductList();
        getCartCount();
    }
}

export function handleAddNoteToggle(e, display = true) {
    const parentEl = e.target.closest('.js--li-body').getElementsByClassName('js--note')[0];

    if (!display) {
        parentEl.getElementsByClassName('js--note-body')[0].value = '';
    }

    return display ? parentEl.classList.remove('none') : parentEl.classList.add('none');
}

async function handleSaveNote(e) {
    const cartItemId = e.target.getAttribute('data-id');

    await updateProductQty({
        cartItemId,
        qty: e.target.getAttribute('data-qty'),
        note: document.querySelector(`.js--note-body[data-id="${cartItemId}"]`).value,
    });
    setProductList();
}

// ==================================================
// HELPERS
// ==================================================

const largeQtyLi = ({ title, qty }) => `<li>
  <div class="pd-modal__list__item">
    <p class="pd-modal__list__info">${title}</p>
    <p class="pd-modal__list__info">${qty}</p>
  </div>
</li>`;

// ==================================================
// INIT
// ==================================================

async function init() {
    noItems = _cart.getElementsByClassName('js--ob-no-items')[0].cloneNode(true);

    hideCartIcon();
    setProductList();
    updateAllowableFreight();

    document
        .getElementsByClassName('js--continue')[0]
        .addEventListener('click', (e) => handleContinue(e));

    document
        .getElementsByClassName('js--pd-modal-close')[0]
        .addEventListener('click', () => closeLargeQuantityModal());

    document
        .getElementsByClassName('js--modal-backorder-close')[0]
        .addEventListener('click', () => toggleModal('backorder', true));

    document
        .getElementsByClassName('js--modal-min-close')[0]
        .addEventListener('click', () => toggleModal('min', true));
}

export default init;
